// enabled for all users
import { Feature } from "../models/feature-toggles";

export const DEFAULT_FEATURES: Feature[] = ["anomaly-detection", "budgets", "cost-comparison"];
